export enum PackageEnum {
    PFF = 'PFF',
    HF = 'HF',
    HTT = 'HTT',
    PFTT = 'PFTT',
    PFTTF = 'PFTTF',
    PFTTNL = 'PFTTNL',
    PFPTTF = 'PFPTTF',
    PFPTTNL = 'PFPTTNL',
    PFPCS = 'PFPCS',
    PFCS = 'PFCS',
    PFP = 'PFP',
    PF = 'PF',
    HS = 'HS',
    PFPF = 'PFPF',
    TNE = 'TNE',
    HTTF = 'HTTF',
}
export const getPackageFullName = (packageEnum: PackageEnum): Array<string> => {
    if (packageEnum && (packageEnum as any).includes("_"))
        packageEnum = packageEnum.split("_")[0] as PackageEnum
    // every string n this array, should have a translation value, and an svg with the SAME NAME
    switch (packageEnum) {
        case PackageEnum.HS: return ['accommodation'];
        case PackageEnum.PF: return ['accommodation', 'skipass'];
        case PackageEnum.PFP: return ['accommodation', 'skipass', 'equipment'];
        case PackageEnum.PFTT: return ['train', 'accommodation', 'skipass',];
        case PackageEnum.PFTTF: return ['train', 'accommodation', 'skipass', 'equipment'];
        case PackageEnum.PFPTTF: return ['train', 'accommodation', 'skipass', 'equipment'];
        case PackageEnum.HTT: return ['train', 'accommodation'];
        case PackageEnum.HTTF: return ['train', 'accommodation'];
        case PackageEnum.PFTTNL: return ['train', 'accommodation', 'skipass'];
        case PackageEnum.PFPTTNL: return ['train', 'accommodation', 'skipass', 'equipment'];
        case PackageEnum.PFCS: return ['accommodation', 'skipass'];
        case PackageEnum.PFPCS: return ['accommodation', 'skipass', 'equipment'];
        case PackageEnum.PFPF: return ['flight', 'accommodation', 'skipass', 'equipment'];
        case PackageEnum.PFF: return ['flight', 'accommodation', 'skipass'];
        case PackageEnum.HF: return ['flight', 'accommodation'];
        case PackageEnum.TNE: return ['train'];

        default: return [];
    }
};